<p>customer-sales-summary works!</p>
